export abstract class AbstractComponent<P extends object> {
  protected el: HTMLElement;
  constructor(
    protected props: P,
    type: string = 'div'
  ) {
    this.el = document.createElement(type);
  }


  protected abstract createContext(): void;
  public abstract render(): void;
}
